<template>
  <div class="basic-block block-example-fortune-base" :style="styles">
    <div class="content-wrap">
      <div class="lead">
        <div class="lead__title">あなたに課せられた宿命と<br>可能性を解放する属性開抛</div>
        <div class="lead__lead">占いTVでは過去～未来の運気の流れほか、<br>あなたのための属性開抛を<br>お楽しみいただけます</div>
        <lp-base-button
          label="<b>属性開抛でもっと占う</b><br>月額528円（税込）"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
      </div>
      <div class="example">
        <div class="example__towa">
          <img src="/static/img/recommend/lp/touwa/counselor.png" alt="" class="example__img">
          <div class="example__text">「ストレートに<br>言ってもいいですか」</div>
        </div>
        <div class="example__talent">
          <div class="example__text">「えっ！泣きそう…<br>まさかそこを突いて<br>くるなんて」</div>
          <img src="/static/img/recommend/lp/common/avatar.png" alt="" class="example__img">
        </div>
        <div class="example__copy">今人気急上昇中の<br>あのタレントも涙！<br>頭と心をつまびらかにし<br>あなたの一番深い部分が癒される</div>        
      </div>
      <div class="subsc">
        <div class="subsc__towa">
          <img src="/static/img/recommend/lp/touwa/counselor5.jpg" alt="" class="subsc__img">
          <div class="subsc__text">よろしければ、あなたについても見てみましょう。ただ、思ってもみない結果になる場合もありますのでご容赦くださいね。</div>
        </div>
        <lp-base-button
          label="<b>属性開抛でもっと占う</b><br>月額528円（税込）"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
        <!-- <ul class="subsc__list">
          <li v-for="(item, i) in subscList" :key="i">{{ item }}</li>
        </ul>
        <div class="subsc__lead">登録した日から30日間、528円（税込）のみで斗弥の属性開抛の各種メニューをはじめ、2000メニュー以上が占い放題！</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockExampleFortune',
  components: {
    LpBaseButton,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: Number,
    subscUrl: String,
  },
  data() {
    return {
      subscList: [
        '◆【属性開抛】で暴露・その結婚に待つ「現実」',
        '◆【属性開抛】今月の開運術',
        '◆その出会いが持つ意味と本来の定め',
        '◆あなたの存在は、相手にどういう影響をもたらす？',
        '◆お相手があなたを好きになったとき、どんな風になる？',
        '◆きょうの試験、うまくいきそう？',
        '◆斗弥があなたに今一番伝えたいこと',
        'etc'
      ]
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      const param = {
        'event_category': `LP${this.lpId}basicresult-subsc-button`,
        'event_label': 1
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-example-fortune-base {
  background: #fff;
  padding: 40px 0 24px;
  .lead {
    padding: 0 0 24px;
    &__title {
      font-weight: bold;
      font-size: 22px;
      line-height: 32px;
      text-align: center;
      color: $l_col_second;
      margin: 0 0 16px;
    }
    &__lead {
      font-weight: bold;
      font-size: 15px;
      line-height: 26px;
      text-align: center;
      margin: 0 0 24px;
    }
  }
  .example {
    background: #F9F5ED;
    border-radius: 10px;
    margin: 0 20px 24px;
    padding: 20px 20px 24px;
    &__towa,
    &__talent {
      display: flex;
      align-items: center;
      margin: 0 auto 16px;
      max-width: 300px;
    }
    &__img {
      flex: 0 1 80px;
      max-width: 80px;
    }
    &__text {
      flex: 1 1 auto;
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
    }
    &__img,
    &__text {
      &:first-of-type {
        padding-right: 7px;
      }
    }
    &__copy {
      font-weight: bold;
      font-size: 18px;
      line-height: 28px;
      text-align: center;
      color: $l_col_second;
      margin: 24px 0 0;
    }
  }
  .subsc {
    // background: #F9F5ED;
    // padding: 40px 20px;
    margin: 0 20px;
    &__towa {
      display: flex;
      margin: 0 auto 24px;
      max-width: 400px;
    }
    &__img {
      flex: 0 1 auto;
      width: 38.3%;
      max-width: 140px;
      margin: 0 10px 0 0;
    }
    &__text {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      font-size: 15px;
      line-height: 22px;
      font-weight: bold;
      color: #fff;
      text-align: justify;
      background: $l_col_second;
      border-radius: 8px;
      padding: 18px 10px;
      margin: 0;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: calc(100% - 1px);
        margin: auto;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-right-color: $l_col_second;
      }
    }
    &__list {
      background: #FFFFFF;
      border-radius: 10px;
      padding: 24px 20px;
      margin: 24px auto;
      max-width: 480px;
      > li {
        list-style: none;
        font-weight: bold;
        font-size: 16px;
        line-height: 28px;
        text-align: justify;
        color: #9C8961;
        text-indent: -1em;
        padding: 0 0 0 1em;
        &:last-child {
          text-align: right;
          font-size: 14px;
        }
      }
    }
    &__lead {
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      margin: auto;
      max-width: 480px;
    }
  }
  .baseButton {
    width: 72%;
    max-width: 320px;
    margin: auto;
    /deep/ {
      .baseButton__button {
        padding: 15px 32px 11px;
      }
      .baseButton__button__label b {
        font-size: 18px;
        line-height: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockExampleFortune.vue